import Vue from 'vue'
import router from './router';
import store from './forms/store/';
import { sync } from 'vuex-router-sync';
sync(store, router);

import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Object.defineProperty(Vue.prototype, '$axios', { value: axios });

import uuid from './utilities/uuid-generator'

import PubNubVue from 'pubnub-vue';
Vue.use(PubNubVue, {
	subscribeKey: "sub-c-bb593ae5-254b-4f6e-a7c4-3237affefb30",
	publishKey: "pub-c-8029bb72-a2eb-45a4-b883-1affadff0f18",
	presence_timeout: 60,
	ssl: true,
	cipherKey: 'encrypt it all',
	uuid,
});

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)

import ElementUI from 'element-ui';
import './element-variables.scss';
// import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

locale.use(lang);
Vue.use(ElementUI);

import App from './App'
Vue.config.productionTip = false

import optionGroup from './forms/sub-components/Option-Group';
Vue.component('option-group', optionGroup);

import uploadImage from './forms/sub-components/Upload-Image.vue';
Vue.component('upload-image', uploadImage);

import uploadNonImage from './forms/sub-components/Upload-Non-Image.vue';
Vue.component('upload-non-image', uploadNonImage);

import uploadNonImageAlt from './forms/sub-components/Upload-Non-Image-Alt.vue';
Vue.component('upload-non-image-alt', uploadNonImageAlt);

import addressPanel from './forms/sub-components/Address-Panel.vue';
Vue.component('address-panel', addressPanel);

import contactPanel from './forms/sub-components/Contact-Panel.vue';
Vue.component('contact-panel', contactPanel);

import { mask } from 'vue-the-mask';
Vue.directive('mask', mask);

import global_config_mixin from './forms/config.js';
Vue.mixin(global_config_mixin);

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput);

export default new Vue({
	store,
	router,
	render: h => h(App)
}).$mount('#app')
